import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { fnGetDataSet } from "@shared/api/restApi";
import SearchPanel from "@widgets/SearchPanel";
import SnGrid from "@shared/components/GridV2/SnGrid";

interface Props {
  Menuprops: menuInfo;
}

// 월별매출분석
const SN_SAL_STX_REP_006 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const baseColumnRef = useRef<any[]>([]);

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
        });
        baseColumnRef.current = rtn.grid.grid1;
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (columns.grid1.length > 0 && dataSources.grid1.length > 0) {
      gridRefs.current.grid1.current?.calculateTotals();
    }
  }, [columns.grid1, dataSources.grid1]);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const params = {
        id: "sn_sal_stx_rep_006_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(params);
      const rows = data[0] || [];
      const customerColumns = createCustomerColumns(rows);
      const pivotRows = createPivotRows(rows);
      setColums({
        grid1: customerColumns,
      });
      setDataSources({
        grid1: pivotRows,
      });
      gridRefs.current["grid1"].current.resetUpdate();
    } catch (error: any) {}
  };

  const createCustomerColumns = (rows: any[]) => {
    const base = structuredClone(baseColumnRef.current);
    const idx = base.findIndex((x: any) => x.cd_column === "nm_cust_sort");
    if (idx < 0) return base;
    const template = base[idx];

    const custList = [...new Set(rows.map((r) => r.nm_cust_sort))];
    const dynamicColumns = custList.map((name: string, i: number) => ({
      ...template,
      cd_column: name,
      nm_column: name,
      no_seq: template.no_seq + i,
      yn_sum: "Y",
    }));

    base.splice(idx, 1, ...dynamicColumns);

    // no_seq 다시 정렬
    base.forEach((c: any, i: number) => {
      c.no_seq = i + 1;
    });

    return base;
  };

  const createPivotRows = (rows: any[]) => {
    const map = new Map();
    rows.forEach((r) => {
      let row = map.get(r.mm);
      if (!row) {
        row = {
          mm: r.mm,
          total: 0,
        };
        map.set(r.mm, row);
      }

      row[r.nm_cust_sort] = r.am_k_saeles;
      row.total += Number(r.am_k_saeles || 0);
    });

    return [...map.values()];
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {},
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 flex flex-col gap-1.5 min-h-0">
        <div className="flex-1 min-h-200">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single" }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    </div>
  );
});

export default SN_SAL_STX_REP_006;
